export default __webpack_public_path__ + "img/archive.fa214bc0.png";